import dynamic from 'next/dynamic';

const MasterclassPage = dynamic(() => import('../../js/pages/MasterclassPage'), {ssr: false});

export default MasterclassPage;
